<div class="card card-custom">
	<div class="card-header">
		<div class="card-title">Detalles</div>
	</div>
	<div class="card-content" [formGroup]="prestacionesForm" #localFormRef="ngForm">
		<div class="card-body">
			<div class="row">
				<table class="table" formArrayName="prestaciones">
					<thead>
						<tr>
							<th>N°</th>
							<th WIDTH="65%">Prestación</th>
							<th>Valor</th>
							<th></th>
						</tr>
					</thead>
					<tbody *ngFor="let prestacion of prestacionesForm.get('prestaciones')['controls']; let i = index">
						<tr [formGroupName]="i">
							<td>{{ i + 1 }}</td>
							<td>
								<input type="text" class="form-control" formControlName="descripcion" (blur)="onSubmit()" />
								<div *ngIf="(localFormRef.touched || localFormRef.dirty) && prestacionesForm.get('prestaciones')['controls'][i].invalid" class="text-danger"></div>
							</td>
							<td>
								<input type="text" class="form-control" formControlName="valor" (blur)="onSubmit()" />
							</td>
							<td>
								<button class="btn btn-danger" (click)="removePrestacion(i)"><i class="flaticon-delete text-white"></i></button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="mb-5">
				<div class="d-flex justify-content-center">
					<button class="btn btn-success" (click)="addPrestacionForm()"><i class="flaticon-add-circular-button"></i>Agregar</button>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="row mt-5">
	<div class="offset-md-7 offset-lg-7 col-md-5 col-lg-5">
		<div class="card">
			<div class="card-body">
				<div class="form-group row mx-auto">
					<div class="col-6 label-control">Líquido a pagar</div>
					<div class="col-6 text-right">
						{{ liquido | currency : "$ " : "symbol" : "1.0-0" : "es" }}
					</div>
				</div>
				<!-- <div class="form-group row mx-auto">
					<div class="col-8 label-control">Porcentaje de Retención</div>
					<div class="col-4 text-right input-group">
						<input type="number" style="text-align: right" [disabled="true"] [(ngModel)]="porcentajeRetencion" class="form-control" (change)="cambiarRetencion()" />
						<div class="input-group-append">
							<span class="input-group-text">%</span>
						</div>
					</div>
				</div> -->
				<div class="form-group row mx-auto">
					<div class="col-6 label-control">Retención ({{ porcentajeRetencion * 100 | number : "1.2-2" }})%</div>
					<div class="col-6 text-right">
						{{ montoRetencion | currency : "$ " : "symbol" : "1.0-0" : "es" }}
					</div>
				</div>
				<div class="form-group row mx-auto">
					<div class="col-6 label-control">Total</div>
					<div class="col-6 text-right">
						{{ totalBruto | currency : "$ " : "symbol" : "1.0-0" : "es" }}
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
